/**
 * YLI GA4 Collection Tracking
 * Version: 1.1.0
 * Created: 2026-01-14
 * Updated: 2026-02-18
 * Purpose: Track collection page views and filter interactions
 * GA4 Events: collection_browse, thread_weight_filter, application_filter, project_type_filter, fiber_type_filter, color_family_filter
 * Spec: docs/ga4-events/ga4-event-tracking-plan.md
 */

(function() {
  'use strict';

  // Track collection page view on load
  function trackCollectionBrowse() {
    const collectionElement = document.querySelector('[data-section-type="collection"]');
    if (!collectionElement) return;

    // Get collection data from URL or data attributes
    const collectionHandle = window.location.pathname.split('/collections/')[1]?.split('?')[0] || 'unknown';
    const productCount = document.querySelectorAll('.product-item, .product-grid-item, [data-product-item]').length;

    // Get sort order from URL params
    const urlParams = new URLSearchParams(window.location.search);
    const sortOrder = urlParams.get('sort_by') || 'default';

    if (typeof gtag === 'function') {
      gtag('event', 'collection_browse', {
        'collection_name': collectionHandle,
        'product_count': productCount,
        'sort_order': sortOrder
      });
    }
  }

  // Track filter changes
  function trackFilterChange(filterType, filterValue, previousValue) {
    const eventName = filterType + '_filter';

    // Map filter type to collection name
    const collectionHandle = window.location.pathname.split('/collections/')[1]?.split('?')[0] || 'unknown';

    if (typeof gtag === 'function') {
      const eventParams = {
        'collection_name': collectionHandle
      };

      // Add type-specific parameters
      if (filterType === 'thread_weight') {
        eventParams.weight_value = filterValue;
        eventParams.previous_filter = previousValue || 'none';
      } else if (filterType === 'application') {
        eventParams.application_type = filterValue;
      } else if (filterType === 'project_type') {
        eventParams.project_type = filterValue;
      } else if (filterType === 'fiber_type') {
        eventParams.fiber_type = filterValue;
      } else if (filterType === 'color_family') {
        eventParams.color_family = filterValue;
      }

      gtag('event', eventName, eventParams);
    }
  }

  // Initialize collection browse tracking
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trackCollectionBrowse);
  } else {
    trackCollectionBrowse();
  }

  // Hook into Shopify's filter form submissions
  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (!form.classList.contains('filters-form') && !form.classList.contains('collection-filter')) {
      return;
    }

    // Get all filter inputs
    const formData = new FormData(form);

    formData.forEach((value, key) => {
      // Detect filter type from input name/value
      const filterName = key.toLowerCase();

      if (filterName.includes('weight') || filterName.includes('wt')) {
        trackFilterChange('thread_weight', value);
      } else if (filterName.includes('application') || filterName.includes('technique')) {
        trackFilterChange('application', value);
      } else if (filterName.includes('project')) {
        trackFilterChange('project_type', value);
      } else if (filterName.includes('fiber') || filterName.includes('material')) {
        trackFilterChange('fiber_type', value);
      } else if (filterName.includes('color')) {
        trackFilterChange('color_family', value);
      }
    });
  });

  // Also hook into AJAX filter updates (Shopify theme may use AJAX)
  const originalFetch = window.fetch;
  window.fetch = function() {
    const url = arguments[0];

    // Check if this is a collection filter request
    if (typeof url === 'string' && url.includes('/collections/') && url.includes('?')) {
      const urlObj = new URL(url, window.location.origin);
      const params = urlObj.searchParams;

      // Parse filter parameters
      params.forEach((value, key) => {
        const filterKey = key.toLowerCase();

        if (filterKey.includes('weight') || filterKey.includes('wt')) {
          trackFilterChange('thread_weight', value);
        } else if (filterKey.includes('application') || filterKey.includes('technique')) {
          trackFilterChange('application', value);
        } else if (filterKey.includes('project')) {
          trackFilterChange('project_type', value);
        } else if (filterKey.includes('fiber') || filterKey.includes('material')) {
          trackFilterChange('fiber_type', value);
        } else if (filterKey.includes('color')) {
          trackFilterChange('color_family', value);
        }
      });
    }

    return originalFetch.apply(this, arguments);
  };

  // Listen for filter clicks (fallback for non-form filters)
  document.addEventListener('click', function(e) {
    const filterButton = e.target.closest('[data-filter], .filter-item, .facet-checkbox, .facet-value');
    if (!filterButton) return;

    const filterValue = filterButton.dataset.filter ||
                       filterButton.dataset.value ||
                       filterButton.textContent.trim();
    const filterLabel = filterButton.closest('[data-filter-type]')?.dataset.filterType ||
                       filterButton.closest('.filter-group')?.querySelector('.filter-group__label')?.textContent.trim().toLowerCase() || '';

    if (filterLabel.includes('weight') || filterValue.toLowerCase().includes('wt')) {
      setTimeout(() => trackFilterChange('thread_weight', filterValue), 100);
    } else if (filterLabel.includes('application') || filterLabel.includes('technique')) {
      setTimeout(() => trackFilterChange('application', filterValue), 100);
    } else if (filterLabel.includes('project')) {
      setTimeout(() => trackFilterChange('project_type', filterValue), 100);
    } else if (filterLabel.includes('fiber') || filterLabel.includes('material')) {
      setTimeout(() => trackFilterChange('fiber_type', filterValue), 100);
    } else if (filterLabel.includes('color')) {
      setTimeout(() => trackFilterChange('color_family', filterValue), 100);
    }
  });

})();
